/**
 * T079: Edit Prompt Route
 * Route for editing an existing prompt
 */

import { createFileRoute } from '@tanstack/react-router'
import { PromptEditPage } from '@/pages/prompts/prompt-edit'

export const Route = createFileRoute('/_authenticated/prompts/$id/edit')({
  component: PromptEditRoute,
})

function PromptEditRoute() {
  const { id } = Route.useParams()
  return <PromptEditPage promptId={id} />
}
